import React from 'react';
const App: React.FC = () => {
  return (
    <h1>:)</h1>
  );
};

export default App;
